import { render, staticRenderFns } from "./InputPhone.vue?vue&type=template&id=b94169fa"
import script from "./InputPhone.vue?vue&type=script&lang=js"
export * from "./InputPhone.vue?vue&type=script&lang=js"
import style0 from "./InputPhone.vue?vue&type=style&index=0&id=b94169fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports